module.exports = __webpack_public_path__ + "fonts/adellesans-regular-webfont.3402557d.ttf";